import { Router } from '@angular/router';
import { AuthService } from './../../../../services/auth.service';
import { Component, OnInit } from '@angular/core';
import {KahpooReverseService} from "../../../../services/kahpooreverse.service";
import {KahpooReverse} from "../../../../models/kahpooReverse.model";
import {environment} from "../../../../environments/environment";
import * as html2pdf from 'html2pdf.js'
import * as XLSX from "xlsx";
import Swal from 'sweetalert2';
import { DatePipe } from '@angular/common';
@Component({
  selector: 'app-reversement-effectues',
  templateUrl: './reversement-effectues.component.html',
  styleUrls: ['./reversement-effectues.component.scss']
})
export class ReversementEffectuesComponent implements OnInit {
  reversemementSelected: KahpooReverse;
  reverses: KahpooReverse[] = [];
  reversesTmp = [];
  url_photo;
  /*
-----------------------------         for all page attribute    --------------------------------
*/
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  tableSizes: any = [10, 15, 30, 50];
  search: any;
  seller = false;
  perPage = 10;
  sorted = 1;

  constructor(private kahpooReverseService:KahpooReverseService, private datePipe: DatePipe,
              private authService: AuthService, private router: Router) { }

  ngOnInit(): void {
    this.authService.isAuthenticated().subscribe(isAuthenticated => {
      this.loadReverses();
    },error=>{
      this.router.navigate(['/login']);
    });
  }
  loadReverses() {
    this.kahpooReverseService.getAllKahpooReversementTermine().subscribe(rs=> {
      this.reverses =rs;
      this.reversesTmp =rs;
      // console.log("Reversements effectués")
      // console.log(rs)
    })
  }

  searchFilter($event: KeyboardEvent) {
    this.kahpooReverseService.getAllKahpooReversementTermine().subscribe(rs=> {
      this.reverses =rs;
      this.reverses = this.reverses.filter(value =>
        value?.user?.firstname?.toUpperCase().includes(this.search.toUpperCase()) ||
        value?.user?.lastname?.toLowerCase().includes(this.search.toUpperCase()) ||
        value?.kahpooReverseUniqueID?.toUpperCase().includes(this.search.toUpperCase()) ||
        value?.user?.username?.toUpperCase().includes(this.search.toUpperCase()) ||
        value?.user?.paymentMethod?.toUpperCase().includes(this.search.toUpperCase()) ||
        value?.user?.phoneNumber?.toUpperCase().includes(this.search.toUpperCase()) ||
        value?.kahpooReverseID?.toUpperCase().includes(this.search.toUpperCase()) ||
        value?.status?.toUpperCase().includes(this.search.toUpperCase()) ||
        value?.transactionDoneBy?.toUpperCase().includes(this.search.toUpperCase()) ||
        value?.transactionNumber?.toUpperCase().includes(this.search.toUpperCase()) ||
        value?.transactionID?.toUpperCase().includes(this.search.toUpperCase()) ||
        value?.transactionDoneBy?.toUpperCase().includes(this.search.toUpperCase()) ||
        value?.user?.email?.toUpperCase().includes(this.search.toUpperCase())||
        value?.user?.firstname?.toUpperCase().includes(this.search.split(" ")[0].toUpperCase()) &&
        value?.user?.firstname?.toUpperCase().includes(this.search.split(" ")[1].toUpperCase()) ||
        value?.user?.lastname?.toUpperCase().includes(this.search.split(" ")[0].toUpperCase()) &&
        value?.user.lastname?.toUpperCase().includes(this.search.split(" ")[1].toUpperCase())
      );
    }, (err) => {
     // console.log('-----> err', err);
    });
  }

  displayPerPage(value: any) {
    this.perPage = parseInt(value, 10);
    //console.log(this.tableSize);
  }
  /*
  end for all page
   */
  disableEndDate = true;
  displayError = false;
  //Récupération de la date de début
  getBeginDate(event:any){
    this.beginDate=event.target.value;
    if(this.beginDate){
      this.disableEndDate = false;
      if(this.beginDate > this.endDate){
        this.displayError = true;
      }else{
        this.displayError = false;
      }
    }else{
      this.disableEndDate = true;
    }
  }
  // Récupération de la date de fin
  getEndDate(event){
    this.endDate=event.target.value;
  }

  selectReverse(reverse: any) {
    this.reversemementSelected = reverse;
    this.url_photo = environment.url_photo + '' + reverse.referenceTransaction;
    //console.log(reverse);
  }

  // Permet d'exporter en format pdf
  exportToPdf(){
    var element = document.getElementById('to-pdf');
    //console.log(element)
    var opt = {
      margin:       1,
      filename:     'Détails du reversement.pdf',
      image:        { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2,useCORS: true },
      jsPDF:        { unit: 'in', format: 'letter', orientation: 'portrait' }
    };

    // New Promise-based usage:
    html2pdf(element, opt);
  }

  exportexcel(fileName): void {
    /* table id is passed over here */
    let element = document.getElementById('excel-table');
    const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, fileName);

  }



  /*
  filtre par date
   */

  beginDate: string = null;
  endDate: string = null;

  filter() {
    if (this.endDate == null || this.beginDate== null) {
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Veuillez choisir une date de début et une date de fin s\'il vous plaît',
        showConfirmButton: false,
        timer: 3500
      })
      return;
    }
    if (this.endDate!= null && this.beginDate!= null && this.beginDate <= this.endDate) {
      const dateString = this.endDate;
      const date = new Date(dateString);
      date.setDate(date.getDate() + 1); // ajoute 1 jour à la date
      this.endDate = this.datePipe.transform(date,'yyyy-MM-dd');
      this.reverses = this.reversesTmp;
      this.reverses = this.reverses.filter((rev) => {
        let dateS = this.datePipe.transform(rev.validateAt, 'yyyy-MM-dd')
        return (dateS >= this.beginDate &&  dateS  <= this.endDate);
      });
    }
  }

  resetFilter() {
    this.loadReverses();
    this.beginDate = null;
    this.endDate = null;
  }

  trier(columnName: keyof KahpooReverse) {
    this.sorted = -this.sorted;
    this.reverses.sort((a, b) => a[columnName] > b[columnName] ? this.sorted : -this.sorted);
  }

}
